import React from "react";

import { useTranslation } from "react-i18next";

import { Row, Col } from "reactstrap";
import LabelField from "components/FormControls/LabelField";
import { useSelector } from "react-redux";

export default function SummaryContractGroups({ contract }) {
  const { t } = useTranslation();

  const comparatorsReducer = useSelector((state) => state.comparatorsReducer);

  const isEnglish = t("locale") === "en";
  const referenceLabel = isEnglish ? "labelEnglish" : "labelFrench";

  let validOperators = comparatorsReducer.comparatorsForSelect.filter((c) => c.comparatorTypeName === "int");

  return (
    <div className={`card mt-3`}>
      <div className="card-body">
        <h5 className="card-title">{t("groups")}</h5>
        <div className="card-text">
          {contract.groups &&
            contract.groups.map((g) => (
              <React.Fragment key={g.id || g.uniqueIdentifier}>
                <hr />
                <Row>
                  <Col md="6">
                    <LabelField labelText={t("nameFrench")} value={g.nameFrench} />
                  </Col>
                  <Col md="6">
                    <LabelField labelText={t("nameEnglish")} value={g.nameEnglish} />
                  </Col>
                </Row>

                <h5 className="mb-1">{t("criterias")}</h5>

                {g.criterias &&
                  g.criterias.map((c) => (
                    <Row key={c.id || c.uniqueIdentifier}>
                      <Col md="6">
                        {c.comparator_Id && (
                          <LabelField
                            labelText={t("group_criteria_operators")}
                            value={validOperators.find((o) => o.id === c.comparator_Id)[referenceLabel]}
                          />
                        )}
                      </Col>
                      <Col md="6">
                        <LabelField labelText={t("value")} value={c.value} />
                      </Col>
                    </Row>
                  ))}
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  );
}
